import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { HomePage } from "../pages/HomePage";
import { App } from "./App";

const NotFoundPage = lazy(() => import("../pages/NotFoundPage").then((module) => ({ default: module.NotFoundPage })));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "*", element: <NotFoundPage /> }
    ]
  }
]);
